const styles = {
  formTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  formCard: {
    width: 390,
    position: "fixed",
    // position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "30px",
  },
};
export default styles;
